import { api } from "../client";
import {
  CommissionExtraFields,
  CommissionFields,
  PartialCommissionExtraFields,
  PartialCommissionFields,
} from "../schema/Commission";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<CommissionFields, CommissionExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialCommissionFields,
  PartialCommissionExtraFields
>;

export const getCommissions = async (config?: ApiRequestConfig) => {
  return api.get<CommissionFields, CommissionExtraFields>(
    "commissions",
    config
  );
};
export const getCommission = (id: number, config?: ApiRequestConfig) => {
  return api.get<CommissionFields, CommissionExtraFields>(
    `commissions/${id}`,
    config
  );
};

export const createCommission = (config: ApiRequestConfigMutate) => {
  return api.create<PartialCommissionFields, PartialCommissionExtraFields>(
    "commissions",
    config
  );
};
export const updateCommission = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<PartialCommissionFields, PartialCommissionExtraFields>(
    `commissions/${id}`,
    config
  );
};
export const deleteCommission = (id: number) => {
  return api.remove<CommissionFields, CommissionExtraFields>(
    `commissions/${id}`
  );
};
